module.exports = __webpack_public_path__ + "static/3-d226c904a5e4d7a9898a55e76d8e930a.png";